import React from 'react';
import { connect } from 'react-redux';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { appRoutes } from '../../config/app_routes';
import withPGTranslation from '../../config/withPGTranslation';
import { useLocalizedPath } from './hooks/useLocalizedPath';
import { getCurrentLocalization } from '../../config/i18n';
import { isMigratedPath } from '../../config/migrated_routes';

const getUpdatedLink = (to, lang, path, location) => {
  let link = to;
  let state = { ...location.state };
  let search = '';
  if (typeof to === 'object') {
    link = to.pathname;
    state = { ...state, ...to.state };
    search = to.search || '';
  }

  const updatedLink = path(lang, link, to.params);
  if (updatedLink) link = updatedLink;

  return { link, state, search };
};

function AppLink({
  to,
  className = '',
  children,
  replace = false,
  onClick,
  alt,
  style,
  itemProp,
  blank,
  rel,
  reloadDocument = false
}) {
  const history = useNavigate();
  const location = useLocation();
  const generatePath = useLocalizedPath();
  const lang = getCurrentLocalization();
  const { link, state, search } = getUpdatedLink(to, lang, generatePath, location);
  const hardNavigate = reloadDocument || isMigratedPath(link);

  const onLinkClick = (e) => {
    if (blank) {
      e.preventDefault();
      return;
    }
    if (onClick) {
      onClick(e);
    }

    if (hardNavigate) return;

    if (window.location.pathname === link) {
      e.preventDefault();
      history({ pathname: link, search }, { state, replace: true });
      return;
    }
    if (link === appRoutes.home) {
      window.scrollTo(0, 0);
    }
  };

  const renderAppLink = () => (
    <Link
      to={ `${ link }${ search || '' }` }
      state={ state }
      rel={ rel }
      className={ className }
      replace={ replace }
      onClick={ onLinkClick }
      alt={ alt }
      style={ style }
      itemProp={ itemProp }
      suppressHydrationWarning
      reloadDocument={ hardNavigate }
    >
      { children }
    </Link>
  );

  return renderAppLink();
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {})(withPGTranslation(AppLink));
